// /*Author: Bhavya*/
// import React from "react";
// import history from "helper/history";

// import {
//     CustomPrimaryButton as SaveButton,
//     CustomGrid as Grid,
//     CustomCell as Cell
// } from "../../customComponents/components";

// import Style from "../../constants/style";

// import LoginStore from "../../stores/loginstore";
// import * as LoginAction from "../../actions/loginaction";
// import UserInfoStores from "../../stores/userInfoStores";
// import i18n from "../../i18nNext";
// export default class EmailVerificationPage extends React.Component {
//     constructor() {
//         super();
//         this.state = {
//             email: LoginStore._getField("details").email_id || ""
//         };
//         this._handleSubmit = this._handleSubmit.bind(this);
//         this._emailVerificationStore = this._emailVerificationStore.bind(this);
//     }

//     componentDidMount() {
//         LoginStore.on("change", this._emailVerificationStore);
//     }
//     componentWillUnmount() {
//         LoginStore.removeListener("change", this._emailVerificationStore);
//     }

//     _emailVerificationStore(type) {
//         if (type === "happayIdField") {
//             let emailVerificationId = LoginStore._getHappayIdField();
//             this._handleSubmit(emailVerificationId.happay_id);
//         }
//     }
//     _handleSubmit(happay_id) {
//         LoginAction.verifyEmailApi({ happay_id });
//     }

//     render() {
//         return (
//             <div style={Style.loginPage.mainContainer}>
//                 <div style={Style.loginPage.leftContainer}>
//                     <div style={Style.loginPage.logoDivStyle}>
//                         <div style={Style.loginPage.happayLogo}>
//                             <a href="https://www.happay.in" target="_blank">
//                                 <img src="/assets/images/logo_black.png" />
//                             </a>
//                         </div>
//                         <div style={Style.loginPage.textBelowLogo}>
//                             {" "}
//                             {i18n.t("pageContent.welcomesYou")}
//                         </div>
//                     </div>
//                     <div style={Object.assign({ margin: 40 }, Style.loginPage.floatingTextStyle)}>
//                         <div style={{ fontFamily: "Roboto-Regular" }}>
//                             {i18n.t("lbl.verifyEmail")}
//                         </div>
//                     </div>
//                     <form onSubmit={this._handleSubmit.bind(this, true)} autoComplete="off">
//                         <div style={{ textAlign: "center" }}>
//                             <div style={Style.loginPage.verificationLink}>
//                                 {i18n.t("pageContent.verificationLinkSend")} : <br />
//                                 <span
//                                     style={{ fontWeight: "normal", fontFamily: "Roboto-Regular" }}
//                                 >
//                                     {this.state.email
//                                         ? this.state.email
//                                         : i18n.t("pageContent.yourRegisteredMail")}
//                                     .
//                                 </span>
//                                 {i18n.t("pageContent.openYourLinkR")}.
//                             </div>
//                             <SaveButton
//                                 type="submit"
//                                 label={i18n.t("pageContent.reSendVerificationMail")}
//                             />
//                         </div>
//                         <div style={{ textAlign: "center", paddingTop: "10px" }}>
//                             <SaveButton
//                                 label={i18n.t("btn.next")}
//                                 onClick={() => {
//                                     history.push("/login/loginpage");
//                                 }}
//                             />
//                         </div>
//                     </form>
//                     <div style={Style.loginPage.verifyMailNote}>
//                         {i18n.t("err.pleaseCheckSpamFolder")}
//                         {i18n.t("err.resendVarificationMail")}
//                     </div>
//                 </div>
//                 <div style={Style.loginPage.regRightContainer}>
//                     <div style={{ marginBottom: 22, fontFamily: "Roboto-Medium", fontSize: 18 }}>
//                         {i18n.t("pageContent.theMantraRelationship")}
//                     </div>
//                     <Grid noSpacing>
//                         <Cell col={6}>
//                             <img src="/assets/images/request_advance.svg" />
//                         </Cell>
//                         <Cell
//                             col={6}
//                             style={{ paddingTop: 36, fontFamily: "Roboto-Regular", fontSize: 14 }}
//                         >
//                             <span style={{ fontSize: 20 }}>1 </span>
//                             {i18n.t("flexi.requestAdvance")}
//                         </Cell>
//                     </Grid>
//                     <Grid noSpacing>
//                         <Cell col={6}>
//                             <img src="/assets/images/create_helpexpense.svg" />
//                         </Cell>
//                         <Cell
//                             col={6}
//                             style={{ paddingTop: 36, fontFamily: "Roboto-Regular", fontSize: 14 }}
//                         >
//                             <span style={{ fontSize: 20 }}>2</span>{" "}
//                             {i18n.t("pageContent.createExpenses")}
//                         </Cell>
//                     </Grid>
//                     <Grid noSpacing>
//                         <Cell col={6}>
//                             <img src="/assets/images/create_helpreport.svg" />
//                         </Cell>
//                         <Cell
//                             col={6}
//                             style={{ paddingTop: 36, fontFamily: "Roboto-Regular", fontSize: 14 }}
//                         >
//                             <span style={{ fontSize: 20 }}>3</span>{" "}
//                             {i18n.t("pageContent.submitTheExpensesReport")}
//                         </Cell>
//                     </Grid>
//                 </div>
//             </div>
//         );
//     }
// }
import React from "react";
import EmailVerificationPage from "@techsoftware/happay-widgets/EmailVerificationPage";
import history from "helper/history";
//---------------- End External Library Import --------------------//

//------------------- Start Actions Dependency Import-------------------------------------//
import * as LoginAction from "../../actions/loginaction";
//------------------- End Actions Dependency Import -------------------------------------//

//------------------- Start Stores Dependency Import -------------------------------------//
import LoginStore from "../../stores/loginstore";
//------------------- End Stores Dependency Import -------------------------------------//

//------------------- Start Helpers Dependency Import -------------------------------------//
import i18n from "../../i18nNext";
//------------------- End Helpers Dependency Import -------------------------------------//

import Common from "../../constants/common";
import HDFCLogo from "../../../public/assets/images/bank/HDFC_Bank_Logo.svg";

export default class emailVerificationPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: LoginStore._getField("details").email_id || "",
            happayId: ""
        };
        this._handleSubmit = this._handleSubmit.bind(this);
        this._emailVerificationStore = this._emailVerificationStore.bind(this);
    }
    componentDidMount() {
        LoginStore.on("change", this._emailVerificationStore);
    }
    componentWillUnmount() {
        LoginStore.removeListener("change", this._emailVerificationStore);
    }
    _emailVerificationStore(type) {
        if (type === "happayIdField") {
            let emailVerificationId = LoginStore._getHappayIdField();
            this.setState({
                happayId: emailVerificationId.happay_id
            });
        }
    }
    _handleSubmit() {
        const { happayId } = this.state;
        LoginAction.verifyEmailApi({ happay_id: happayId || LoginStore._getHappayIdField()?.happay_id }, true);
    }

    render() {
        const { email } = this.state;
        const { ProductLogo, breakPoints } = this.props;
        return (
            <EmailVerificationPage
                containerClassName={`signin-container ${Common._checkIfHdfcUrl() ? 'hdfcPortal': 'happayPortal'}`}
                logo={Common._checkIfHdfcUrl() ? HDFCLogo : ProductLogo}
                breakPoints={breakPoints}
                onSignIn={this._handleSubmit}
                emailVerificationHeader={i18n.t("lbl.verifyEmail")}
                emailVerificationContentOne={
                    <div className="font-14 margin-t-24 align-center">
                        {i18n.t("pageContent.verificationLinkSend")} <br />
                        <span className="font-14 align-center fw-500" style={{ color: "#1d7cbf" }}>
                            {email ? email : i18n.t("pageContent.yourRegisteredMail")}
                        </span>{" "}
                    </div>
                }
                emailVerificationContentTwo={i18n.t("pageContent.openYourLinkR")}
                // emailVerificationFooter={i18n.t("pageContent.spamFolder")}
                reSendButtonText={i18n.t("pageContent.reSendVerificationMail")}
                emailVerificationFooter={
                    <div>
                        Not received yet? Please check your spam folder or you can
                        <span
                            className="font-10 align-center fw-500"
                            style={{ color: "#1d7cbf", cursor: "pointer" }}
                            onClick={() => {
                                history.push("/login");
                            }}
                        >
                            &nbsp;Click Here&nbsp;
                        </span>
                        to Sign in via mobile number. You can re-send the verification email later
                        by visiting “My Profile” page.
                    </div>
                }
            />
        );
    }
}
